export default {
  loginTitle: 'GEAR 登錄',
  login: '立即登錄',
  placehdUsern: '請輸入賬號',
  placehdPwd: '請輸入密碼',
  rememberPwd: '記住密碼',
  forgetLoginInfo: '忘記密碼',
  noAccountMsg: '還沒有賬號?',
  noAccountMsg2: '', // 占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位我占占占

  registerTitle: 'GEAR 註冊',
  register: '立即註冊',
  registerSuccess: '註冊成功',
  invitationCode: '邀請碼',
  invitationCodeMsg: '請輸入邀請碼',
  mobile: '電話號碼',
  useEmailLogin: '使用郵箱登錄',
  useMobileLogin: '使用手機登錄',

  mobileAreaCode: '區號',
  verification: '驗證碼',
  getVerification: '獲取驗證碼',
  confirmPassword: '確認密碼',
  mobileAreaCodeMsg: '請選擇區號',
  emailMsg: '請輸入郵箱',
  mobileMsg: '請輸入手機號',
  email: '郵箱',
  verificationMsg: '請輸入驗證碼',
  nextStep: '下一步',
  lastStep: '上一步',
  applyPeopleName: '顾问姓名',
  applyPeopleNameMsg: '請輸入顾问姓名',
  company: '院校/機構名',
  companyMsg: '請輸入院校/機構名',
  genderMsg: '請選擇性別',
  departmentMsg: '請選擇部門',
  positionMsg: '請選擇職位',
  country: '當前居住國家/地區',
  state: '現居省份',
  city: '現居城市',
  address: '聯系地址',
  addressMsg: '請輸入聯系地址',
  zipCode: '郵政編碼',
  hasAccountMsg: '已經擁有賬戶?',
  hasAccountMsg2: '', // 占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位我占占占

  password: '密碼',
  validPwdNum: '包含字母、數字和特殊字符，8-12位',
  validPwdMsg: '兩次輸入密碼不一致',
  validUser: '請輸入正確的賬號',
  loginVerification: '驗證失敗，請重新登錄',
  noInvitationCode: '用戶未填寫邀請碼',
  invalidInvitationCode: '邀請碼無效',
  accountExpired: '該賬戶已經失效',
  userPawdError: '用戶或密碼錯誤！',
  resetPassword:'重置密碼',
  oldpassword: '請輸入舊密碼',
  newpassword: '請輸入新密碼',
  confirmpassword: '確認密碼',
  confirmreset: '確認重置',
  outReset: '退出重置',
  isOut: '是否退出重設密碼',
  operaConfirmTips: '操作確認',
  confirm: '確定',
  cancel: '取消',
  cancelOut: '取消退出',
  twopsdNotConsistent: '兩次輸入密碼不一致!',
  passwordResetFailed:'重置密碼失敗',
  passwordResetSuccessful:'重設密碼成功，請重新登入',
  returnLogin: '返回登錄',
  verifyEmail: '郵箱驗證',
  ModifyPWD: '密碼更改',
  verifyEmailSuccess: '驗證成功',
  verifyInitEmailSuccess: '用戶初始化驗證完成！',
  passwordReset: '密碼重置',
  roleTips: '當前角色：顧問 （如需更改角色請聯繫BD）',
  upgradeNoticeTitleEn: 'Platform upgrade notice',
  upgradeNoticeTitleZh: '平台升級提示',
  upgradeNoticeLine2En: 'ISSUE platform has been migrated to GEAR 3.0 AI driven platform. You will be redirect to GEAR 3.0 automatically after 10 seconds, or please click "Access GEAR 3.0" to access immediately. ',
  upgradeNoticeLine2Zh: 'SSUE平台已迁移至GEAR 3.0人工智能平台。10秒后您将自动跳转至GEAR 3.0，或点击“访问GEAR 3.0”立即访问。',
  upgradeNoticeLine3En: 'Should you have any techncial query, please contact itsupport.global@geaworld.org',
  upgradeNoticeLine3Zh: '如有任何技术问题，请联系 itsupport.global@geaworld.org',
  continueLoginZh: '继续登录',
  continueLogin: 'Continue',
  transferToNewPlatform: 'Access GEAR 3.0 ({seconds}s)',
  transferToNewPlatformZh: '访问GEAR3.0',
};
